import { useState } from 'react';
import { CssBaseline, Box } from '@mui/material';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Inicio from './pages/Inicio';
import Servicios from './pages/Servicios';
import Contacto from './pages/Contacto';

function App() {
  const [currentPage, setCurrentPage] = useState('inicio');

  const renderPage = () => {
    switch (currentPage) {
      case 'servicios':
        return <Servicios />;
      case 'contacto':
        return <Contacto />;
      case 'inicio':
      default:
        return (
          <Inicio
            onGoToServicios={() => setCurrentPage('servicios')}
            onGoToContacto={() => setCurrentPage('contacto')}
          />
        );
    }
  };

  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#ffffff',
        }}
      >
        <Navbar currentPage={currentPage} onChangePage={setCurrentPage} />

        <Box component="main" sx={{ flexGrow: 1 }}>
          {renderPage()}
        </Box>

        <Footer />
      </Box>
    </>
  );
}

export default App;
